import React from 'react';
import { IProps, IState } from './types';
import { Link } from 'react-router-dom';
import SliderBoundlessPcMobile from 'components/SliderBoundlessPcMobile';
import PageNavControls from 'components/PageNavControls';
import { RouterSettings } from 'constants/models/routerSettings';
import { ValueAddContent, DetailContent } from 'bff/models/promotion';
import commonService from 'utils/commonService';
// import moment from 'moment';
import moment from 'moment-timezone';
import storageService from 'utils/storageService';
import { storageKeys } from 'constants/enums/storageKeys.enum';
import { LogInInfo } from 'bff/models/login';
import sweetAlertService from 'utils/sweetAlertService';
import { SweetAlertIcon } from 'constants/enums/sweetAlertIcon.enum';
import _ from 'lodash';
import { ValueAddCount } from 'constants/enums/showCount.enum';
import promotionListService from 'bff/services/promotionListService';
import PromotionTypeDefines from 'constants/models/promotionTypeDefines';
import { PromotionSectionType } from 'constants/enums/promotionType.enum';

class PromotionsService extends React.Component<IProps, IState> {
  componentDidMount () {
    // 頁面初始取得傳入的加值公告內容
    if (!storageService.getItem(storageKeys.PromotionDetail)) {
      this.props.history.goBack();
      return;
    }

    let prePromotionTitle = PromotionTypeDefines[PromotionSectionType.ValueAdd];
    if (this.props.history.location.state) {
      const { promotionType } : any = this.props.history.location.state;
      if (promotionType) {
        prePromotionTitle = PromotionTypeDefines[promotionType as PromotionSectionType];
      }
    }

    const valueAddInfo = JSON.parse(storageService.getItem(storageKeys.PromotionDetail)) as ValueAddContent;

    this.setState({ valueAddInfo: valueAddInfo, prePromotionTitle: prePromotionTitle });
  }

  componentDidUpdate () {
    // 內容資料有更動，移至畫面上方
    commonService.scrollToTop();
  }

  componentWillUnmount () {
    // 頁面關閉，暫存明細資料
    storageService.removeItem(storageKeys.PromotionDetail);
    storageService.setItem(storageKeys.PromotionDetail, JSON.stringify(this.state.valueAddInfo));

    // 頁面關閉更新暫存的優惠列表資訊，設定使用區塊為對應區塊
    if (storageService.getItem(storageKeys.TempInfo)) {
      let tempInfo = JSON.parse(storageService.getItem(storageKeys.TempInfo));
      storageService.removeItem(storageKeys.TempInfo);

      tempInfo = {
        ...tempInfo,
        activeTab: PromotionSectionType.ValueAdd
      };

      storageService.setItem(storageKeys.TempInfo, JSON.stringify(tempInfo));
    }
  }

  render () {
    /**
   * @description 產生連結區塊
  */
    const handleCreateLinkArea = (insureUrl: string, downloadUrl: string) => {
      const loginInfo = JSON.parse(storageService.getItem(storageKeys.LoginInfo)) as LogInInfo;
      let linkArea = (
        <>
          <Link to={RouterSettings.Signup} className="business-cooperation__main-btn--black">加入會員</Link>
          <Link to={insureUrl} className="business-cooperation__main-btn--red">我要投保</Link>
        </>
      );

      if (loginInfo) {
        linkArea = (
          <>
            <Link to={insureUrl} className="business-cooperation__main-btn--black">我要投保</Link>
            <span
              onClick={() => handleDownloadFile(downloadUrl)}
              className="element__link business-cooperation__main-btn--red"
            >
              下載優惠券
            </span>
          </>
        );
      }

      return linkArea;
    };

    /**
 * @description 根據路徑下載檔案
*/
    const handleDownloadFile = (downloadUrl: string) => {
      try {
        commonService.downloadFile(downloadUrl, '');
      } catch {
        sweetAlertService.modal({
          icon: SweetAlertIcon.Info,
          title: '下載失敗',
          html: '無法取得相關資訊'
        });
      }
    };

    /**
 * @description 建立圖片區塊
*/
    const handleCreateSlide = (detailContents: DetailContent[]) => {
      if (!detailContents) return;

      const childs = _.map(detailContents, (content: DetailContent, index: number) => {
        if (index >= ValueAddCount.Default) return;

        return (
          <SliderBoundlessPcMobile.Item key={index}>
            <span>
              <img src={content.INFO_VALUE} alt={content.INFO_LINK} style={{ width: '100%' }} />
            </span>
          </SliderBoundlessPcMobile.Item>
        );
      });

      return (
        <SliderBoundlessPcMobile loopSetting={detailContents?.length === 3} name="inner-page-b-ads-slider">
          {childs}
        </SliderBoundlessPcMobile>
      );
    };

    /**
 * @description 點選上下一則的事件
*/
    const handleNextPrevClick = async (sn: number) => {
      if (!sn) return;
      const valueAddInfo = await promotionListService.fetchValueAdd(sn);
      if (!valueAddInfo) return;

      storageService.removeItem(storageKeys.PromotionDetail);
      storageService.setItem(storageKeys.PromotionDetail, JSON.stringify(valueAddInfo));
      this.setState({ valueAddInfo: valueAddInfo });
    };

    return this.state && this.state.valueAddInfo && (
      <div className="promotions-service">
        {/* 商業合作對象 */}
        <div className="business-cooperation">
          <div className="template-container">
            <div className="template-content">
              <div className="business-cooperation__header">
                <div className="business-cooperation__period">
                  <span>{`合作期間：${moment(this.state.valueAddInfo.START_DATE).format('YYYY/MM/DD')} ~ ${moment(this.state.valueAddInfo.END_DATE).format('YYYY/MM/DD')}`}</span>
                </div>
                <div className="business-cooperation__title">{this.state.valueAddInfo.TITLE}</div>
                <p className="business-cooperation__desc">{this.state.valueAddInfo.SUBTITLE}</p>
              </div>
              <div className="business-cooperation__main">
                <div
                  className="business-cooperation__main-cover-photo"
                  style={{
                    backgroundImage: `url(${this.state.valueAddInfo.IMAGE_URL})`,
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center'
                  }}
                />
                <div className="business-cooperation__main-content">
                  <div className="business-cooperation__main-desc">
                    <div>{commonService.htmlParser(this.state.valueAddInfo.EVENT_DESC)}</div>
                  </div>
                  <div className="business-cooperation__main-controls">
                    {handleCreateLinkArea(this.state.valueAddInfo.APPLY_URL, this.state.valueAddInfo.COUPON_URL)}
                  </div>
                </div>
              </div>
              <div className="business-cooperation__notes">
                <div className="business-cooperation__notes-title">注意事項</div>
                <ol>
                  {
                    _.map(this.state.valueAddInfo.NOTE, (note: string, index: number) => <li key={index}>{note}</li>)
                  }
                </ol>
              </div>
            </div>
          </div>
        </div>
        {/* 商業合作對象廣告圖 */}
        <div className="business-cooperation-ads">
          {handleCreateSlide(this.state.valueAddInfo.INFO_LIST)}
        </div>
        {/* 頁面導航控制項 */}
        <PageNavControls
          prevBtnLink="/"
          onPrevClick={() => handleNextPrevClick(this.state.valueAddInfo?.PREV_SN || 0)}
          nextBtnLink="/"
          onNextClick={() => handleNextPrevClick(this.state.valueAddInfo?.NEXT_SN || 0)}
          navBtnLink={RouterSettings.Promotions.List}
          navBtnText={`回${this.state.prePromotionTitle}頁`}
          prevSN={this.state.valueAddInfo.PREV_SN}
          nextSN={this.state.valueAddInfo.NEXT_SN}
        />
      </div>
    );
  }
};

export default PromotionsService;
